import { render, staticRenderFns } from "./ManagePerson.vue?vue&type=template&id=eab9f5d6&"
import script from "./ManagePerson.vue?vue&type=script&lang=js&"
export * from "./ManagePerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports